import * as React from 'react';
import styled from 'styled-components';
import { PageWrapper } from '@mlc/web-ui-toolkit';
import ClientDataExchangeContainer from '../containers/ClientDataExchange/ClientDataExchangeContainer';
import { ScreenSize } from '../../enums';

const ClientDataExchangeHome: React.FunctionComponent = () => (
	<StyledPageWrapper>
		<ClientDataExchangeContainer />
	</StyledPageWrapper>
);

export default ClientDataExchangeHome;

const StyledPageWrapper = styled(PageWrapper)`
	margin-bottom: 80px;
	margin-top: 50px;

	@media (max-width: ${ScreenSize.small}) {
		margin-right: 10px;
		margin-left: 10px;
	}
`;
